// Vue 2 版本的状态管理 - 使用 Vue.observable
import Vue from 'vue'

const state = Vue.observable({
  activeMenu: 'status' // status | video | alarm | culture
})

export const menuStore = {
  get activeMenu() {
    return state.activeMenu
  },
  setActiveMenu(menu) {
    state.activeMenu = menu
  }
}


